<template>
    <el-form @submit.native.prevent="save" ref="form" label-position="top" id=this.table enctype="multipart/form-data">
		<el-form-item label="Secciones existentes" v-if="sectionsApiShow">
			<el-select v-model="section" filterable @change="loadSection" placeholder="Select" >
				<el-option-group
				v-for="group in sectionsApi"
				:key="group.label"
				:label="group.label">
					<el-option
						v-for="item in group.options"
						:key="item.value"
						:label="item.label"
						:value="item.value">
					</el-option>
				</el-option-group>
			</el-select>
		</el-form-item>
        <el-row type="flex" justify="space-between">
             <el-col :span="11">
                <el-form-item label="Título" :class="(getErrorTitle ? 'error' : false)">
                    <el-input v-model="template.title"></el-input>
                    <div v-if="getErrorTitle" class="el-form-item__error">El título es obligatorio</div>
                </el-form-item>
            </el-col>
			<el-col :span="1"></el-col>                    
			<el-col :span="11">
                <el-form-item label="URL" :class="(getErrorURL ? 'error' : false)">
                    <el-input v-model="template.url"></el-input>
                    <div v-if="getErrorURL" class="el-form-item__error">La URL es obligatoria</div>
                </el-form-item>
            </el-col>
			<el-col :span="1"></el-col>                    
			<el-col :span="11">
                <el-form-item label="Icono">
					<el-input v-model="template.icon"  :prefix-icon="template.icon"></el-input>
					<a :href="'/dashboard/' + $route.params.db + '/icons/'" target="_blank" class="link">Iconos</a>
                </el-form-item>
            </el-col>
			<el-col :span="1"></el-col>                    
			<el-col :span="11">
                <el-form-item label="Color" :class="(errorTitle ? 'error' : false)">
					<el-color-picker
						v-model="template.color"
						show-alpha
						:predefine="predefineColors">
					</el-color-picker>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>

</template>
<script>
	import ApiService from "@/common/api.service";
	import { API_UPLOADS } from "@/common/config";
	import Cropper from '@/components/Dashboard/commons/cropper.vue';

export default {
	name: 'calidad',
	props: ["content"],
	components: {
		'app-cropper': Cropper
	},
	created() {
		if (this.content) this.getContent();
		this.$root.$on("saveContent", (id) => {
			this.id = id;
			this.section_id = id
			this.setSave();
		});

		this.getSections()
	},
	watch: {
		$route(to) {
			if (this.content) this.getContent();
		}
	},
  	data() {
		return {
			table: "calidad",
			template: {
				title: null,
				icon: null,
				color: "",
				url: null
			},
			errorTitle: true,
			errorURL: true,
			id: false,
			predefineColors: [
				'#7f3f96',
				'#fd4010',
				'#6eb2c9',
				'#b39d25',
				'#7f757d',
				'#ffc525',
				'#d18daa',
				'#2f8268'
			],
			sectionsApi: [],
			sectionsApiShow: false,
			section: ''
		}
	},
	methods: {
		async getSections(){
			const response = await ApiService.post("dashboard/sections-page", {
				table: "notifications",
				token: localStorage.getItem("token"),
				project_id: localStorage.getItem("table"),
			})
			this.sectionsApi = response.data.map( e => {
				return e.pagina
			}).filter(function(item, pos, self) {
				return self.indexOf(item) == pos
			}).map( e => {
				return {label: e , options: []}
			}).map( o => {
				response.data.map( e => {
					if(o.label == e.pagina){
						o.options.push({
							value: e.id,
							label: e.title,
							urlpagina: e.urlpagina,
							url: e.url,
							icon: e.icon
						})
						return e
					}
				})
				return o
			})
			this.sectionsApiShow = true
		},
		async getContent() {
			const a = await ApiService.post("dashboard/table", {
				table: this.table,
				token: localStorage.getItem("token"),
				project_id: localStorage.getItem("table"),
				id: this.$route.params.content_id
			})
			this.template = a.data;
		},
		loadSection() {
			this.sectionsApi.map( e => {
				e.options.filter( o => {
					if(o.value === this.section) {
						this.template = {
							title: o.label,
							icon: o.icon,
							color: this.predefineColors[Math.floor(Math.random()*this.predefineColors.length)],
							url: `/modulo/${o.urlpagina}/${o.url}`
						}
					}
				})
			})
		},
		setSave() {
			this.content != 0 ? this.update() :  this.insert();
		},
		async update() {
			const a = await ApiService.post("dashboard/editform", {
				table: this.table,
				token: localStorage.getItem("token"),
				project_id: localStorage.getItem("table"),
				form: this.template,
				id: this.$route.params.content_id
			})
		},
		async insert() {
			const a = await ApiService.post("dashboard/editform", {
				table: this.table,
				token: localStorage.getItem("token"),
				project_id: localStorage.getItem("table"),
				form: this.template
			})
			if(a.status === 200) {
				const b = await ApiService.post("dashboard/editform", {
					table: "contents",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					form: {
						template_id: 6,
						registro_id: a.data
					}
				})
				if(b.status === 200) {
					ApiService.post("dashboard/editform", {
						table: "sections_contents",
						token: localStorage.getItem("token"),
						project_id: localStorage.getItem("table"),
						form: {
							section_id: this.section_id,
							content_id: b.data
						}
					})
				}
			}
		}
	},
	computed: {
		getErrorTitle() {
			return this.errorTitle;
		},
		getErrorURL() {
			return this.errorURL;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/pages/templates/calidad.vue